import DatePicker from 'vue2-datepicker';
import FmsProject from '../../fmsProject';
import FmsTower from '../../fmsTower';
import FmsFloor from '../../fmsFloor';
import FmsUnit from '../../fmsUnit';
import appStrings from '@/app/utility/string.utility';
import store from '../../../../../../store';
export default {
  name: 'SubUnitDetails',
  components: {
    DatePicker,
    FmsProject,
    FmsTower,
    FmsFloor,
    FmsUnit
  },
  data() {
    return {
      unsubscribe: null,
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      showFmsSubUnitDetails: false,
      showFmsComponent: false,
      editMode: false,
      tab: null,
      fmsProj: {
        value: null,
        text: null
      },
      fmsTower: {
        value: null,
        text: null
      },
      fmsFloor: {
        value: null,
        text: null
      },
      fmsUnit: {
        value: null,
        text: null
      },
      defaultValue: {
        value: null,
        text: null
      },
      flag: null,
      fmsSubUnitName: null,
      fmsSubUnitId: 0,
      start_date_end_date: null,
      start_date: null,
      end_date: null,
      active: true,
      defaultFlag: false,
      dummy: false,
      freeze: false
    };
  },
  mounted() {
    this.fmsSubUnitRowDtl = store.state.shared.fmsSubunitRecord;
    if (this.fmsSubUnitRowDtl) {
      this.fillFmsSubUnitDetails(this.fmsSubUnitRowDtl);
    } else if (store.state.shared.subUnitd) {
      this.getSubUnitDetailsById();
    } else {
      this.editMode = true;
    }
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'update') {
          this.editMode = true;
        }
        if (actionName === 'save' && this.editMode) {
          this.addEditFmsSubUnit();
        }
      }
    });
  },
  methods: {
    addEditFmsSubUnit() {
      const payload = {
        active: this.active,
        default_flag: this.defaultFlag,
        dummy: this.dummy,
        fms_sub_unit_id: this.fmsSubUnitId,
        fms_sub_unit_name: this.fmsSubUnitName,
        fms_unit_id: this.fmsUnit.value,
        freeze_flag: this.freeze,
        start_date: this.start_date,
        end_date: this.end_date
      };
      this.loader = false;
      this.$store
        .dispatch('unitInventory/addEditFmsSubUnit', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.isSuccess = true;
            this.editMode = false;
            this.responseMsg = response.data.message;
            const subunitResult = response.data.data;
            this.fmsSubUnitId = subunitResult.fms_sub_unit_id;
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    getSubUnitDetailsById() {
      const subUnitd = store.state.shared.subUnitd;
      this.loader = false;
      this.$store
        .dispatch('unitInventory/getSubUnitDetailsById', subUnitd)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.fillFmsSubUnitDetails(response.data.data);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    setChildName(tab) {
      //method for child modal name
      if (tab === 'FmsTower') {
        return (this.childName = 'FMS Tower');
      } else if (tab === 'FmsFloor') {
        return (this.childName = 'FMS Floor');
      } else if (tab === 'FmsUnit') {
        return (this.childName = 'FMS Unit');
      } else if (tab === 'FmsProject') {
        return (this.childName = 'FMS Project');
      }
    },
    hideFmsComponent(flag, name) {
      this.showFmsComponent = flag;
      this.tab = name;
      this.setChildName(this.tab);
    },
    fillFmsSubUnitDetails(item) {
      this.fmsProj = {
        value: item.fms_project_id,
        text: item.fms_project_name
      };
      this.fmsTower = {
        value: item.fms_tower_id,
        text: item.fms_tower_name
      };
      this.fmsFloor = {
        value: item.fms_floor_id,
        text: item.fms_floor_name
      };
      this.fmsUnit = {
        value: item.fms_unit_id,
        text: item.fms_unit_name
      };
      this.fmsSubUnitName = item.fms_sub_unit_name;
      this.fmsSubUnitId = item.fms_sub_unit_id;
      this.start_date = item.start_date;
      this.end_date = item.end_date;
      this.active = item.active;
      this.defaultFlag = item.default_flag;
      this.dummy = item.dummy;
      this.freeze = item.freeze_flag;
    },
    selectedFmsUnit(item) {
      this.fmsUnit = {
        value: item.fms_unit_id,
        text: item.unit_name
      };
      this.fmsProj = {
        value: item.fms_project_id,
        text: item.fms_project_name
      };
      this.fmsTower = {
        value: item.fms_tower_id,
        text: item.fms_tower_name
      };
      this.fmsFloor = {
        value: item.fms_floor_id,
        text: item.floor_name
      };
      this.showFmsComponent = false;
    },
    disabledDates(date) {
      const restrictedDate = new Date(this.start_date);
      restrictedDate.setHours(0, 0, 0, 0);
      return date < restrictedDate;
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === this.fmsUnit.value) {
        this.fmsUnit = this.defaultValue;
        this.fmsProj = this.defaultValue;
        this.fmsTower = this.defaultValue;
        this.fmsFloor = this.defaultValue;
      } else if (vsetCode === this.fmsProj.value) {
        this.fmsProj = this.defaultValue;
        this.fmsTower = this.defaultValue;
        this.fmsFloor = this.defaultValue;
      } else if (vsetCode === this.fmsTower.value) {
        this.fmsTower = this.defaultValue;
        this.fmsFloor = this.defaultValue;
      } else if (vsetCode === this.fmsFloor.value) {
        this.fmsFloor = this.defaultValue;
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
